// 1 core in millicores — used as the default CPU per pod for single-core pods
export const DU_DEFAULT_MILLICORES_PER_POD = 1000;

// Training pod
export const DU_TRAINING_CPU_MILLICORES_PER_POD = 1600;
export const DU_TRAINING_RAM_MIB_PER_POD = 4 * 1024; // 4 GiB (applies to both CPU and GPU nodes)

// Digitizer pod
export const DU_DIGITIZER_PAGES_PER_HOUR_PER_POD = 2880;
export const DU_DIGITIZER_CPU_MILLICORES_PER_POD = 2 * DU_DEFAULT_MILLICORES_PER_POD; // 2 cores
export const DU_DIGITIZER_RAM_MIB_PER_POD = 3.3 * 1024; // 3.3 GiB

// Framework pod
export const DU_FRAMEWORK_PAGES_PER_HOUR_PER_POD = 1384;
export const DU_FRAMEWORK_RAM_MIB_PER_POD = 1.2 * 1024; // 1.2 GiB

// OOB Classifier pod
export const DU_CLASSIFIER_PAGES_PER_HOUR_PER_POD = 1200;
export const DU_CLASSIFIER_RAM_MIB_PER_POD = 2.384 * 1024; // 2.384 GiB

// Custom Classifier pod
export const DU_CUSTOM_CLASSIFIER_PAGES_PER_HOUR_PER_POD = 15000;
export const DU_CUSTOM_CLASSIFIER_CPU_MILLICORES_PER_POD = 1.05 * DU_DEFAULT_MILLICORES_PER_POD; // 1.05 cores
export const DU_CUSTOM_CLASSIFIER_RAM_MIB_PER_POD = 1 * 1024; // 1 GiB

// OOB Extractor pod (GPU-based; RAM always counted)
export const DU_OOB_EXTRACTOR_PAGES_PER_HOUR_GPU_PER_POD = 2571;
export const DU_OOB_EXTRACTOR_RAM_MIB_PER_POD = 10.384 * 1024;    // 10.384 GiB

// Custom Extractor pod (GPU-based; RAM always counted)
export const DU_CUSTOM_EXTRACTOR_PAGES_PER_HOUR_GPU_PER_POD = 1029;
export const DU_CUSTOM_EXTRACTOR_RAM_MIB_PER_POD = 2.5 * 1024; // 2.5 GiB

// OCR pod (GPU-based; RAM always counted)
export const DU_OCR_PAGES_PER_HOUR_PER_POD = 1800;
export const DU_OCR_RAM_MIB_PER_POD = 3 * 1024;               // 3 GiB

// Throughput slowdown factor when running GPU models on CPU nodes
export const DU_CPU_INFERENCE_SLOWDOWN_FACTOR = 5;

// Extended OCR pod (CPU-based)
export const DU_EXTENDED_OCR_CPU_MILLICORES_PER_POD = 1.05 * DU_DEFAULT_MILLICORES_PER_POD; // 1.05 cores
export const DU_EXTENDED_OCR_RAM_MIB_PER_POD = 1664;             // 1664 MiB (1.625 GiB)
